import styled from "styled-components";

/**
 * Container for the form-only open view.
 * Takes up full height and width of its parent.
 *
 * IMPORTANT: position: relative is required so that the FormOverlay
 * (which uses position: absolute with inset: 0) stays contained within
 * this container instead of escaping to fill the viewport.
 */
export const FormOnlyContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;
`;

/**
 * Container for displaying error state when form is unavailable.
 * Centered content with padding for readability.
 */
export const ErrorStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 32px 24px;
  text-align: center;
`;

export const ErrorIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.warnLight};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.warn};
`;

export const ErrorTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grayDarkest};
  margin: 0 0 8px 0;
`;

export const ErrorMessage = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.grayDark};
  margin: 0;
  max-width: 280px;
`;
